import React from 'react';
import {
  Box,
} from '@mantine/core';
import WorldlineTechnologies from './WorldlineTechnologies';
import Projects from '../../../Projects';

interface ExperienceProfessionalWorldlineProps {
  [x: string]: any,
}

export default function ExperienceProfessionalWorldline(
  { ...props }: ExperienceProfessionalWorldlineProps,
) {
  return (
    <Box {...props}>
      <Projects i18nKey="experience.content.professional.content.worldline.contents.projects" />
      <WorldlineTechnologies initialOpenState={false} />
    </Box>
  );
}
